import React from 'react';

class Download extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section
          className="download-section pt-100 background-img"
          style={{
            backgroundImage: "url('img/app-hero-img.png')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover"
          }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7">
                <div className="download-content text-white pb-100">
                  <h2 className="text-white">
                    Descarga la app, y vive una experiencia Frisbee
                  </h2>
                  <p className="lead">
                    Es fácil descargarse la app, registrarse y empezar a encontrar tus marcas favoritas en Frisbee.
                    Evoluciona tus compras, encuentra los mejores descuentos y cumple con el distanciamiento social.
                  </p>
                  <p class="lead">
                    Cuando te registres, recibirás $5 OFF en tu primera compra.
                  </p>

                  <div className="download-btn">
                    <a href="/#" className="btn google-play-btn mr-3">
                      <span className="ti-android"></span> Google Play
                    </a>
                    <a href="/#" className="btn app-store-btn">
                      <span className="ti-apple"></span> App Store
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="download-img d-flex align-bottom">
                  <img
                    src="img/cupones-download.png"
                    alt="download"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Download;
